import React, { useEffect, useState } from 'react';
import myLogo from 'assets/img/brand/banner.png';
import {
  Box,
  Drawer,
  Toolbar,
  IconButton,
  Divider,
} from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSidebar } from 'contexts/SidebarContextProvider';
import { useWorkspaces } from 'contexts/WorkspacesContextProvider';
import { useAuthorization } from 'contexts/AuthContextProvider.jsx';
import { useProjects } from 'contexts/ProjectsContextProvider';
import { useService } from 'contexts/ServiceContextProvider';
import { useNotification } from 'contexts/NotificationContextProvider';
import NewWorkspaceMember from 'components/Modals/AddWorkspaceMember';
import ProjectList from './ProjectList';
import WorkspaceList from './WorkspaceList';
import SidebarExtraButtons from './SidebarExtraButtons';
import TopBar from 'components/Topbar/Topbar'
import { useTranslation } from "react-i18next";
import "../../css/main.css";
import "../../css/components/Sidebar/Sidebar.css";
import { useLocation, matchPath } from 'react-router-dom';
import { getCachedImageOrFetch } from '../../cache/imageCache';
import { useImageCache } from 'contexts/ImageCacheProvider';

export default function PersistentDrawerLeft() {
  const { t } = useTranslation();

  const { isOpen, openSidebar, closeSidebar, sidebarRef } = useSidebar();
  const [showMoreOptions, setShowMoreOptions] = React.useState(false);
  const [showMoreOptionsProjects, setShowMoreOptionsProjects] = React.useState(false);
  const workspaceContext = useWorkspaces();
  const myWorkspaces = workspaceContext.workspaces;
  const workspaceWorkersRaw = workspaceContext.workspaceWorkers;
  const getCurrentlyLoggedUser = workspaceContext.getCurrentlyLoggedUser;
  const projectsContext = useProjects();
  const myProjects = projectsContext.projects;
  const myCurrentProject = projectsContext.currentProject;
  const { setCurrentProject } = useProjects();
  const {
    WhoAmI,
    getProjectWorkers,
    AddUserToProject,
    RemoveUserFromProject,
    MarkNotificationAsRead,
    SendWorkspaceInvite,
    WorkspaceInviteUpdate,
    MarkAllNotificationAsRead
  } = useService();

  const [avoidMisfire, setAvoidMisfire] = useState(false);
  const [openNewWorkSpaceMemberModal, SetOpenNewWorkSpaceMemberModal] = useState(false);

  const [workspaceWorkers, setWorkspaceWorkers] = useState([]);
  const [projectWorkers, setProjectWorkers] = useState([]);
  const { myNotifs, SetMyNotifs, unreadNotifications, fetchNotifications, markAllAsRead } = useNotification();
  const [showNewWorkspace, setShowNewWorkspace] = useState(false);

  const handleMarkAllAsRead = async () => {
    markAllAsRead();
    MarkAllNotificationAsRead();
  }

  const handleAvatarGroupClick = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleNavigateToProfile = () => {
    const loggedUserID = getLoggedUser();

    if (loggedUserID) {
      window.location.href = `/workflow/profile/${loggedUserID}`;
    }
  };

  const handleNavigateToSupport = () => {
    window.location.href = `/workflow/support`;
  };

  const { getLoggedUser } = useAuthorization();
  const { pathname } = useLocation();

  const isWorkflowProjects = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/projects/*", end: false },
      pathname
  );

  const isWorkflowProjectsNew = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/projects/new", end: true },
      pathname
  );

  const isWorkflowProjectsEdit = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/projects/:projectId/edit", end: true },
      pathname
  );

  const staticIndexPaths = [
    "/workflow/index",
    "/workflow/success-payment",
    "/workflow/failed-payment",
    "/workflow/success-cancel",
    "/workflow/failed-cancel",
    "/workflow/success-suspend",
    "/workflow/failed-suspend",
    "/workflow/success-activate",
    "/workflow/failed-activate",
    "/workflow/feature-unavailable",
  ];
  const isWorkflowIndex = staticIndexPaths.some(p => pathname === p);

  const isWorkflowSettings = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/settings", end: false },
      pathname
  );
  const isWorkflowMembers = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/members", end: false },
      pathname
  );

  const isProjectDetails = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/projects/:projectId/details", end: true },
      pathname
  );

  const isProjectArchive = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/projects/:projectId/archive", end: true },
      pathname
  );

  const isProjectBoard = !!matchPath(
      { path: "/workflow/workspace/:workspaceId/projects/:projectId", end: true },
      pathname
  );

  const isVacations = !!matchPath(
      { path: "/workflow/:workspaceId/calendar/vacations", end: true },
      pathname
  );
  const isVacationsOverview = !!matchPath(
      { path: "/workflow/:workspaceId/calendar/overview", end: true },
      pathname
  );
  const isWorkflowCalendar = !!matchPath(
      { path: "/workflow/:workspaceId/calendar/*", end: false },
      pathname
  );

  const { cacheClearCount } = useImageCache();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open_Element1 = Boolean(anchorEl);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const open_Element2 = Boolean(anchorEl2);
  const loggedUserID = getLoggedUser();
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [myLoggedUser, setMyLoggedUser] = useState(null);
  const [myUserInMemberFormat, setMyUserInMemberFormat] = useState();


  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const fetchCurrentUser = async () => {
      const user = await WhoAmI();
      setMyUserInMemberFormat(user);
      if (user?.is_superuser) {
        setShowNewWorkspace(true);
      } else {
        if (user?.owns_workspaces) {
          setShowNewWorkspace(false);
        } else {
          setShowNewWorkspace(true);
        }
      }
    };

    fetchCurrentUser();

  }, [WhoAmI, cacheClearCount]);



  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredProjectWorkers = projectWorkers?.filter((user) =>
    user.full_name.toLowerCase().includes(searchValue.toLowerCase()) &&
    workspaceWorkersRaw?.some((w) => w.id === user.id)
  );

  const activeProjectWorkers = projectWorkers?.filter((user) =>
    workspaceWorkersRaw?.some((w) => w.id === user.id)
  );

  const filteredWorkspaceWorkers = workspaceWorkers?.filter((user) =>
      user.full_name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const workspaceWorkersRawFiltered = workspaceWorkersRaw?.filter((user) =>
      user.full_name.toLowerCase().includes(searchValue.toLowerCase())
  );

  let buttonText = t("sidebar.project_board");
  if (window.location.pathname.endsWith('/details')) {
    buttonText = t("sidebar.project_details");
  } else if (window.location.pathname.endsWith('/archive')) {
    buttonText = t("sidebar.project_archives");
  } else {
    buttonText = t("sidebar.project_board");
  }

  let buttonWorkspaceText = t("sidebar.projects");
  if (window.location.pathname.endsWith('/settings')) {
    buttonWorkspaceText = t("sidebar.workspace_settings");
  } else {
    buttonWorkspaceText = t("sidebar.projects");
  }

  if (window.location.pathname.endsWith('/settings')) {
    buttonWorkspaceText = t("sidebar.workspace_settings");
  } else if (window.location.pathname.endsWith('/members')) {
    buttonWorkspaceText = t("sidebar.workspace_members");
  } else {
    buttonWorkspaceText = t("sidebar.projects");
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (myWorkspaces[0] && isWorkflowProjects && !isWorkflowProjectsEdit && !isWorkflowProjectsNew) {
      getProjectWorkers(myWorkspaces[0].id, getProjectIDFromNavBar()).then(async (workers) => {

        // Cache project worker images
        const cachedWorkers = await Promise.all(
          workers.map(async (worker) => {
            const result = await getCachedImageOrFetch(worker.image, `worker-${worker.id}`);
            if (!result) return worker;
            return { ...worker, image: result.blobUrl ?? worker.image };
          })
        );

        setProjectWorkers(cachedWorkers);

        const filteredWorkers = workspaceWorkersRaw.filter(
          (worker) => !cachedWorkers.some((projectWorker) => projectWorker.id === worker.id)
        );
        setWorkspaceWorkers(filteredWorkers);
      });
    }
  }, [isWorkflowProjects, myWorkspaces[0], workspaceWorkersRaw, cacheClearCount]);


  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (myWorkspaces[0] && workspaceWorkersRaw) {
      setMyLoggedUser(getCurrentlyLoggedUser);
    }
  }, [workspaceWorkersRaw]);



  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!loggedUserID) return;

    fetchNotifications(loggedUserID); // always fetch on mount / page change

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        fetchNotifications(loggedUserID);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [loggedUserID]);

  const handleDrawerOpen = () => {
    openSidebar();
  };

  const handleDrawerClose = () => {
    closeSidebar();
  };

  const handleWorkspaceClick = () => {
    setShowMoreOptions(!showMoreOptions);
  };



  const handleNewWorkSpaceMemberModalOpen = () => {
    SetOpenNewWorkSpaceMemberModal(true);
  };

  const handleNewWorkSpaceMemberModalClose = () => {
    SetOpenNewWorkSpaceMemberModal(false);
  };



  const handleClickProjectMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseProjectMenu = () => {
    setAnchorEl(null);
  };

  const handleClickProjectMemberMenu = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleCloseProjectMemberMenu = () => {
    setAnchorEl2(null);
  };

  const handleNotifOpen = (event) => {
    setNotifAnchorEl(event.currentTarget);
  };

  const handleNotifClosed = () => {
    setNotifAnchorEl(null);
  };

  const handleNotificationClick = async (processed_notification) => {
    if (processed_notification.option_select === 'Workspace-Invite') {
      return;
    }

    if (processed_notification.workspace_id && processed_notification.workspace_id !== myWorkspaces[0].id) {
      await workspaceContext.handleWorkspaceChange(processed_notification.workspace_id, false);
    }

    const notification_to_edit = myNotifs.find(
        (notification) => notification.id === processed_notification.id
    );
    notification_to_edit.is_read = true;

    SetMyNotifs((prevNotifs) => {
      return prevNotifs.map((notif) =>
          notif.id === notification_to_edit.id ? notification_to_edit : notif
      );
    });

    if (processed_notification.hyper) {
      const workspaceId = processed_notification.workspace_id || myWorkspaces[0]?.id;

      const hyperWithWorkspace = processed_notification.hyper.replace(
          'workflow/projects/',
          `workflow/workspace/${workspaceId}/projects/`
      );

      let fullUrl = `${window.location.origin}/${hyperWithWorkspace}`;

      if (
          processed_notification.type === "Vacation" &&
          processed_notification.invite_identifier
      ) {
        const urlObj = new URL(fullUrl);
        urlObj.searchParams.set("TrackerID", processed_notification.invite_identifier);
        fullUrl = urlObj.toString();
      }

      await workspaceContext.handleWorkspaceChange(workspaceId, false);
      await markNotificationAsRead(processed_notification);
      window.location.href = fullUrl;
    }
  };



  const handleWorkspaceInvite = async (notification, AcceptedInvite) => {
    setAvoidMisfire(true);

    try {
      const response = await WorkspaceInviteUpdate(notification.id, notification.invite_identifier, AcceptedInvite, loggedUserID);

      if (response.status === 200) {
        // Extract the updated notification data from the response
        const updatedNotification = {
          ...response.data,
          is_read: false, // Override is_read to false on the frontend only
        };

        // Update myNotifs array with the updated notification
        SetMyNotifs((prevNotifs) =>
            prevNotifs.map((notif) =>
                notif.id === updatedNotification.id ? updatedNotification : notif
            )
        );
      }
    } catch (error) {
      console.error("Error updating workspace invite:", error);
    }
  };



  const getProjectIDFromNavBar = () => {
    let currentPath = window.location.pathname;
    let currentHash = window.location.hash;

    const pathParts = currentPath.split('/');

    const isDashboard = currentPath.endsWith('/dashboard');
    const isDetails = currentPath.endsWith('/details');
    const isSettings = currentPath.endsWith('/settings');
    const isArchive = currentPath.endsWith('/archive');
    const hasTaskAnimation = !!currentHash; // Boolean check for hash

    let projectId;
    if (isDashboard || isDetails || isSettings || isArchive) {
      projectId = pathParts[pathParts.length - 2];
    } else {
      projectId = pathParts[pathParts.length - 1];
    }


    ////This can be removed in some time, this is just not to screw up current emails that might be sent out etc with the /#350 instead of just #350
    if (hasTaskAnimation && !projectId) {
      projectId = pathParts[pathParts.length - 2];
    }


    return projectId;
  };



  const handleAddUserToProject = async (user_id) => {
    const response = await AddUserToProject(myWorkspaces[0].id, getProjectIDFromNavBar(), user_id);
    if (response?.status === 200) {
      const userToAdd = workspaceWorkers.find((user) => user.id === user_id);
      if (userToAdd) {
        setProjectWorkers((prevWorkers) => [...prevWorkers, userToAdd]);
        const updatedWorkspaceWorkers = workspaceWorkers.filter((user) => user.id !== user_id);
        setWorkspaceWorkers(updatedWorkspaceWorkers);
      }
    }
  };

  const handleRemoveUserFromProject = async (user_id) => {
    const response = await RemoveUserFromProject(myWorkspaces[0].id, getProjectIDFromNavBar(), user_id);
    if (response.status === 200) {
      const userToRemove = projectWorkers.find((user) => user.id === user_id);
      if (userToRemove) {
        const updatedProjectWorkers = projectWorkers.filter((user) => user.id !== user_id);
        setProjectWorkers(updatedProjectWorkers);
        setWorkspaceWorkers((prevWorkers) => [...prevWorkers, userToRemove]);
      }
    }
  };


  const markNotificationAsRead = async (notification) => {
    setAvoidMisfire(true);
    try {
      await MarkNotificationAsRead(notification.id);
    } catch (error) {
      console.error('Marking Notification as Read Failed:', error.message);
    } finally {
      setTimeout(() => {
        setAvoidMisfire(false);
      }, 1000);
    }
  };

  const FormatTimestamp = (timestamp) => {
    const parsedTimestamp = new Date(timestamp);
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    return parsedTimestamp.toLocaleString('en-US', options);
  };

  const handleSendInvite = async (email) => {
    setAvoidMisfire(true);
    try {
      await SendWorkspaceInvite(myWorkspaces[0].id, email);
    } catch (error) {
      console.error('Sending Invite Failed:', error.message);
    } finally {
      setTimeout(() => {
        setAvoidMisfire(false);
      }, 1000);
    }
    handleNewWorkSpaceMemberModalClose();
  };

return (
    <Box className="sidebar-main-box">
      <TopBar
        isOpen={isOpen}
        handleDrawerOpen={handleDrawerOpen}
        isWorkflowCalendar={isWorkflowCalendar}
        isWorkflowProjects={isWorkflowProjects}
        isWorkflowProjectsNew={isWorkflowProjectsNew}
        isWorkflowProjectsEdit={isWorkflowProjectsEdit}
        isProjectDetails={isProjectDetails}
        buttonText={buttonText}
        open_Element1={open_Element1}
        handleClickProjectMenu={handleClickProjectMenu}
        anchorEl={anchorEl}
        handleCloseProjectMenu={handleCloseProjectMenu}
        projectWorkers={activeProjectWorkers}
        handleAvatarGroupClick={handleAvatarGroupClick}
        open_Element2={open_Element2}
        handleClickProjectMemberMenu={handleClickProjectMemberMenu}
        anchorEl2={anchorEl2}
        handleCloseProjectMemberMenu={handleCloseProjectMemberMenu}
        searchValue={searchValue}
        handleSearchChange={handleSearchChange}
        filteredProjectWorkers={filteredProjectWorkers}
        myLoggedUser={myLoggedUser}
        loggedUserID={loggedUserID}
        handleRemoveUserFromProject={handleRemoveUserFromProject}
        filteredWorkspaceWorkers={filteredWorkspaceWorkers}
        handleAddUserToProject={handleAddUserToProject}
        isWorkflowIndex={isWorkflowIndex}
        isWorkflowMembers={isWorkflowMembers}
        isWorkflowSettings={isWorkflowSettings}
        isProjectArchive={isProjectArchive}
        isProjectBoard={isProjectBoard}
        isVacations={isVacations}
        myWorkspaces={myWorkspaces}
        buttonWorkspaceText={buttonWorkspaceText}
        workspaceWorkersRaw={workspaceWorkersRaw}
        workspaceWorkersRawFiltered={workspaceWorkersRawFiltered}
        handleNewWorkSpaceMemberModalOpen={handleNewWorkSpaceMemberModalOpen}
        myNotifs={myNotifs}
        handleNotifOpen={handleNotifOpen}
        notifAnchorEl={notifAnchorEl}
        handleNotifClosed={handleNotifClosed}
        unreadNotifications={unreadNotifications}
        handleNotificationClick={handleNotificationClick}
        FormatTimestamp={FormatTimestamp}
        handleWorkspaceInvite={handleWorkspaceInvite}
        getLoggedUser={getLoggedUser}
        myUserInMemberFormat={myUserInMemberFormat}
        getProjectIDFromNavBar={getProjectIDFromNavBar}
        isVacationsOverview={isVacationsOverview}
        handleMarkAllAsRead={handleMarkAllAsRead}
        closeSidebar={closeSidebar}
      />

      <Drawer
        className={`sidebar-drawer ${isOpen ? 'open' : 'closed'}`}
        variant='persistent'
        anchor='left'
        open={isOpen}
        ref={sidebarRef}
      >
        <Toolbar className="sidebar-toolbar">
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon className="sidebar-text" />
          </IconButton>
          <a href='/workflow/index'>
            <img className="sidebar-image" src={myLogo} alt='' />
          </a>
        </Toolbar>

        <WorkspaceList
          handleWorkspaceClick={handleWorkspaceClick}
          showMoreOptions={showMoreOptions}
          showNewWorkspace={showNewWorkspace}
          setCurrentProject={setCurrentProject}
          myWorkspaces={myWorkspaces}
          workspaceContext={workspaceContext}
        />

        <Divider className="sidebar-divider" />

        <Box
            className="sidebar-project-list-box"
            sx={{ minHeight: myCurrentProject ? "88px" : "68px" }}
        >
          <ProjectList
              setShowMoreOptionsProjects={setShowMoreOptionsProjects}
              showMoreOptionsProjects={showMoreOptionsProjects}
              myProjects={myProjects}
              myCurrentProject={myCurrentProject}
              myWorkspaces={myWorkspaces}
              projectsContext={projectsContext}
          />
        </Box>

        <Divider className="sidebar-divider" />

        <SidebarExtraButtons
            handleNavigateToProfile={handleNavigateToProfile}
            handleNavigateToSupport={handleNavigateToSupport}
            workspaceId={myWorkspaces[0]?.id}
        />
      </Drawer>

      {myWorkspaces[0] && myWorkspaces[0].name && (
            <NewWorkspaceMember
                openNewWorkSpaceMemberModal={openNewWorkSpaceMemberModal}
                handleNewWorkSpaceMemberModalClose={handleNewWorkSpaceMemberModalClose}
                handleSendInvite={handleSendInvite}
                workspace_name={myWorkspaces[0].name}
                avoidMisfire={avoidMisfire}
            />
        )}
      </Box>
  );
}